import { PremiumToast } from '@/components/Stripe/PremiumToast';
import axios from 'axios';
import { t } from 'i18next';
import { toast } from 'react-hot-toast';
import { NavigateFunction } from 'react-router-dom';

// Store for tracking shown toast IDs to prevent duplicates
const shownToastIds = new Set<string>();

type Errors = Record<string, string[]>;

export const handleError = async (
  error: unknown,
  setErrors?: (errors: Errors) => void,
  navigate?: NavigateFunction,
) => {
  if (error && axios.isAxiosError(error)) {
    if (error.response?.data?.errors && setErrors) {
      setErrors(error.response.data.errors);
    } else if (error.response?.data?.message) {
      const errorId = `${error.response?.status}-${error.response?.data?.message}`;
      if (!shownToastIds.has(errorId)) {
        shownToastIds.add(errorId);
        setTimeout(() => {
          shownToastIds.delete(errorId);
        }, 1000);
        if (
          error.response?.data?.message.startsWith('premium_required') &&
          navigate
        ) {
          toast.custom(toastInstance => (
            <PremiumToast
              toastInstance={toastInstance}
              navigate={navigate}
              customLabel={error.response?.data?.custom_label ?? null}
            />
          ));
        } else {
          toast.error(error.response?.data.message);
        }
      }
    } else {
      const genericErrorId = 'generic-error';
      if (!shownToastIds.has(genericErrorId)) {
        shownToastIds.add(genericErrorId);
        setTimeout(() => {
          shownToastIds.delete(genericErrorId);
        }, 1000);
        toast.error(t('common:error.occurred'));
      }
    }
  }
};
